import { CanfarServiceType } from '../utils/types';
import { RootState } from './store';

export function getSelectedCanfar(state: RootState): CanfarServiceType | undefined {
  const selectedCanfarId = state.global.selectedCanfarId;
  if (selectedCanfarId === undefined || selectedCanfarId === '') {
    return undefined;
  }
  return state.data.canfarServices?.find((service) => service.id === selectedCanfarId);
}
